// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"faf15d79","248":"3d51d190","597":"1a18282f","962":"c379010c"}[chunkId] + ".chunk.css";
};